import { serializeLiveCheckTripParams as serializeParams } from '../actions/utils';
import * as types from './types';

function setTripCheckoutData(lcId, data) {
    return {
        meta: {
            lcId,
        },
        payload: data,
        type: types.SET_TRIP_CHECKOUT_DATA,
    };
}

function setTripLiveCheck(lcParams, data) {
    const lcId = typeof lcParams === 'string'
        ? lcParams
        : serializeParams(lcParams);

    return {
        meta: {
            lcId,
        },
        payload: data,
        type: types.SET_TRIP_LIVE_CHECK,
    };
}

function removeTripLiveChecks(lcId) {
    return {
        meta: {
            lcId,
        },
        type: types.REMOVE_TRIP_LIVECHECKS,
    };
}

export {
    removeTripLiveChecks,
    setTripCheckoutData,
    setTripLiveCheck,
};
